import authRoles from 'app/auth/authRoles';
import UserManagement from './UserManagement';
import React from 'react';

const UserManagementConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/usermanagement',
			element: (
				<React.Suspense fallback={<>...</>}>
					<UserManagement />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.admin,
};

export default UserManagementConfig;
